<template src="./ButtonSearchComponent.html"></template>
<script>
export default {
  name: 'ButtonSearchComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
  .btn-search {
    padding: 6px 10px;
  }
</style>
